import React, { useEffect, useState } from 'react';
import CheckboxList, { FilterListItem } from '../CheckboxList';
import { dispatchService } from '../../../services/central-api/dispatch';
import { FieldValues, Path } from 'react-hook-form';
import { useAuth } from '../../../context/Auth';
import FilterDependencyMessage from '../../Filters/FilterDependencyMessage';
import { translate } from '../../../services/translate';

function EventTagList<
    TFieldValues extends FieldValues,
    TName extends Path<TFieldValues>,
>({ name, actingBodyId }: { name: TName; actingBodyId?: number; }) {
    const [items, setItems] = useState<FilterListItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const { user } = useAuth();

    async function getOccurrenceTags(authenticatedUser: AuthenticatedUser) {
        try {
            if ((authenticatedUser.isAdmin || authenticatedUser.permissions.dispatch_manage_all_acting_bodies_occurrences) &&
                !actingBodyId) {
                return;
            }
            const tags = await dispatchService.getDropDownOccurrenceTags(actingBodyId ?? authenticatedUser.actingBodyUnitId);
            setItems(tags.map(tag => ({ label: tag.name, value: tag.id, color: tag.color })));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }

    }

    useEffect(() => {
        if (!user) {
            return;
        }
        getOccurrenceTags(user);
    }, [user]);

    if ((user?.isAdmin || user?.permissions.dispatch_manage_all_acting_bodies_occurrences) &&
        !actingBodyId) {
        return <FilterDependencyMessage message={translate('selectActingBodyFirst')} />;
    }

    return <CheckboxList name={name} items={items} renderBadge isLoading={isLoading} />;
}

EventTagList.getCount = CheckboxList.getCount;

export default EventTagList;
